import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const safePortal = (children: React.ReactNode) => {
  if (
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    !document.body
  )
    return null;
  return createPortal(children, document.body);
};

const useSafePortal = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const createSafePortal = (children: React.ReactNode) => {
    if (!isMounted) return null;
    return safePortal(children);
  };

  return createSafePortal;
};

export default useSafePortal;
